import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import graphicalOn from '../../../assets/graphical_view_on.png';
import graphicalOff from '../../../assets/graphical_view_off.png';
import tabularOn from '../../../assets/tabular_view_on.png';
import tabularOff from '../../../assets/tabular_view_off.png';

import { nsColorConstants } from '../../../util/GlobalConstant';

import { BrushLineChart } from '../../../components/ns/BrushChart';

import SystemLoadTable from './SystemLoadTable';

import style from './index.scss';

const throughputMeta = {
  colors: [nsColorConstants.throughPut, nsColorConstants.peerAvg]
};

const TABULAR_VIEW = 0;
const GRAPH_VIEW = 1;

class SystemLoad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: GRAPH_VIEW
    };
  }

  onToggleGraphView = () => {
    if (this.state.currentView !== GRAPH_VIEW) {
      this.setState({
        currentView: GRAPH_VIEW
      });
    }
  };

  onToggleTabularView = () => {
    if (this.state.currentView !== TABULAR_VIEW) {
      this.setState({
        currentView: TABULAR_VIEW
      });
    }
  };

  renderGraphView = () => {
    if (this.props.data) {
      return (
        <div className={classnames(style.dashboardChart)}>
          <div className={classnames(['card col-md-12', style.cardWrapper])}>
            <div className={classnames(style.cardHeaderMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-4')}>Open Alerts</div>

                <div className={classnames('col-md-8 text-right')}>
                  {this.renderViewSwitcher()}
                </div>
              </div>
            </div>
            <div className={classnames('card-body', style.cardBodyMore)}>
              <div className={classnames('col-md-12')}>
                <p className={style.throughputTitle}>Throughput</p>
                {this.renderThroughput()}
                <div className={style.throughputCaption}>
                  <p>Performance Chart</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return <h5>Loading Supervisor Dashboard data...</h5>;
  };

  renderTabularView = () => {
    if (this.props.data) {
      return (
        <div className={classnames(style.dashboardChart)}>
          <div className={classnames(['card col-md-12', style.cardWrapper])}>
            <div className={classnames(style.cardHeaderMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-4')}>Open Alerts</div>

                <div className={classnames('col-md-8 text-right')}>
                  {this.renderViewSwitcher()}
                </div>
              </div>
            </div>
            <div className={classnames('card-body', style.cardBodyMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-12')}>
                  <SystemLoadTable data={this.props.data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return <h5>Loading Supervisor Dashboard data...</h5>;
  };

  renderThroughput = () => {
    const { data } = this.props;
    const throuMeta = throughputMeta;
    if (data) {
      throuMeta.names = data.fields;
      return (
        <BrushLineChart
          text={'Throughput'}
          data={data.data}
          dataKey="date"
          chartMeta={throuMeta}
        />
      );
    }

    return null;
  };

  renderViewSwitcher = () => {
    const { currentView } = this.state;
    return (
      <div className="btn-group">
        <button onClick={() => this.onToggleGraphView()}>
          <img
            src={currentView === GRAPH_VIEW ? graphicalOn : graphicalOff}
            alt="graphical view"
          />
        </button>
        <button onClick={() => this.onToggleTabularView()}>
          <img
            src={currentView === TABULAR_VIEW ? tabularOn : tabularOff}
            alt="tabular view"
          />
        </button>
      </div>
    );
  };

  render() {
    const { currentView } = this.state;
    if (currentView === GRAPH_VIEW) {
      return this.renderGraphView();
    }

    return this.renderTabularView();
  }
}

SystemLoad.propTypes = {
  data: PropTypes.object
};

export default SystemLoad;
